import {ProductGridItem} from 'modules/ProductsGrid/components/ProductGridItem/ProductGridItem';
import {ProductGridItemData} from 'modules/ProductsGrid/lib/types';
import {FC} from 'react';

import {Text} from 'components/Text/Text';

import styles from './GridGroupAdditional.module.css';

type Props = {
    productsList: number[];
    groupId: number;
    productsEntities: Record<number, ProductGridItemData>;
    previewIsClickable: boolean;
    parentId?: string;

    makeHandleRemove: ({
        productId,
        groupId,
    }: {
        productId: number;
        groupId: number;
    }) => () => void;
    makeHandleRestore: ({
        productId,
        groupId,
    }: {
        productId: number;
        groupId: number;
    }) => () => void;
    makeHandleChangeCount: (id: number) => (count: number) => void;
    makeHandlePreviewClick: (id: number) => () => void;
};
export const GridGroupAdditional: FC<Props> = ({
    productsEntities,
    productsList,
    previewIsClickable,
    parentId,
    groupId,
    makeHandleRemove,
    makeHandleRestore,
    makeHandleChangeCount,
    makeHandlePreviewClick,
}) => {
    // Проверяем, является ли родительская группа "Барные стойки"
    const isBarModules = parentId === '2862';

    return (
        <div className={styles.group}>
            <div className={styles.groupHead}>
                <div className={styles.groupHeadName}>
                    {isBarModules
                        ? 'Дополнительные модули'
                        : 'Дополнительные товары'}
                </div>
                <Text.Regular14 className={styles.groupHeadLabel}>
                    Не входят в стоимость
                </Text.Regular14>
            </div>
            {productsList.map((productId) => {
                const product = productsEntities[productId];
                return (
                    <ProductGridItem
                        key={product.id}
                        className={styles.product}
                        data={product}
                        amount={product.count}
                        removed={product.deleted}
                        onChangeCount={makeHandleChangeCount(product.id)}
                        onRestore={makeHandleRestore({
                            productId: product.id,
                            groupId: groupId,
                        })}
                        onRemove={makeHandleRemove({
                            productId: product.id,
                            groupId: groupId,
                        })}
                        onPreviewClick={
                            previewIsClickable
                                ? makeHandlePreviewClick(product.id)
                                : undefined
                        }
                        withoutRemovedState
                    />
                );
            })}
        </div>
    );
};
